/** The API request "Diagnose" tab — a thin adapter over the shared AI chat
 *  panel (features/ai-diag). Same backend tool as the import-runs Diagnose
 *  tab; this entry point covers "my webhook never became an import". The
 *  task label carries the request's UUID (the small integer pk would collide
 *  as a label substring); task params carry the integer pk. */
import { useMemo } from 'react';

import * as apiRequestsApi from '@/api/apiRequests';
import { AiDiagChat } from '@/features/ai-diag/AiDiagChat';
import type { AiDiagAdapter } from '@/features/ai-diag/types';

export function AiDiagnosePanel({ id, uuid }: { id: number; uuid: string }) {
  const adapter: AiDiagAdapter = useMemo(
    () => ({
      launchContext: apiRequestsApi.diagnoseLaunchContext,
      start: (body) => apiRequestsApi.startDiagnose(id, body),
      taskType: 'import_diagnose',
      subjectNoun: 'webhook',
      subjectTitle: `API request ${id}`,
      questionPlaceholder: 'e.g. "Why did this webhook never become an import?"',
      labelContains: uuid,
      matchesSubject: (params) =>
        (params as { api_request_id?: number } | null)?.api_request_id === id,
    }),
    [id, uuid],
  );
  return (
    <AiDiagChat
      adapter={adapter}
      subjectNote={
        "The AI sees this webhook's request and response, whatever import " +
        'runs it spawned, backend logs, tenant config and the booking ' +
        "system's current records — nothing else."
      }
    />
  );
}
